import { Dispatch } from 'react'
import {
  AnalysisReportFilters,
  AnalysisReportOrders,
  Pagination,
} from 'generated/graphql'
import { getInitialState } from './AnalysisReportsContext'

export type TAnalysisReportsState = {
  filterBy: AnalysisReportFilters
  orderBy: AnalysisReportOrders
  pagination: Pagination
}

export type TAnalysisReportsAction =
  | {
      type: 'SET_FILTER_BY'
      filterBy: AnalysisReportFilters
    }
  | {
      type: 'SET_ORDER_BY'
      orderBy: AnalysisReportOrders
    }
  | {
      type: 'SET_PAGINATION'
      pagination: Pagination
    }
  | {
      type: 'RESET'
    }
  | {
      type: 'RE_INIT'
      filterBy: AnalysisReportFilters
      orderBy: AnalysisReportOrders
      pagination: Pagination
    }

const analysisReportsReducer = (
  state: TAnalysisReportsState,
  action: TAnalysisReportsAction,
) => {
  const initialData = getInitialState()

  switch (action.type) {
    case 'SET_FILTER_BY':
      return { ...state, filterBy: action.filterBy }
    case 'SET_ORDER_BY':
      return { ...state, orderBy: action.orderBy }
    case 'SET_PAGINATION':
      return { ...state, pagination: action.pagination }
    case 'RESET':
      return initialData
    case 'RE_INIT':
      return {
        filterBy: action.filterBy,
        orderBy: action.orderBy,
        pagination: action.pagination,
      }

    default:
      return state
  }
}
export default analysisReportsReducer

export const dispatchFilterByAction = (
  dispatch: Dispatch<TAnalysisReportsAction>,
  filter: AnalysisReportFilters,
) => {
  dispatch({
    type: 'SET_FILTER_BY',
    filterBy: filter,
  })
}
